
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import './UpgradePromptTooltip.css'

class UpgradePromptTooltip extends Component {
  constructor () {
    super()

    this.state = {
      isActive: false
    }
  }
  render () {
    const { children, message } = this.props
    const { isActive } = this.state
    const classes = classnames({
      UpgradePromptTooltip: true,
      'UpgradePromptTooltip--isActive': isActive
    })

    return (
      <div className={classes}>
        <div
          className='UpgradePromptTooltip-content'
          onMouseEnter={() => this.setState({ isActive: true })}
          onMouseLeave={() => this.setState({ isActive: false })}>{children}</div>
        <div className='UpgradePromptTooltip-tip ui-Copy tiny'>{message}</div>
      </div>
    )
  }
}

UpgradePromptTooltip.displayName = 'UpgradePromptTooltip'

UpgradePromptTooltip.propTypes = {
  children: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
}

export default UpgradePromptTooltip



// WEBPACK FOOTER //
// ./ui/UpgradePromptTooltip.js